export default function Alert({ children, tone, className = "" }) {
    if (tone === "positive") {
        return (
            <div className={`${className} p-2 outline outline-[1px] outline-offset-[-1px] outline-green-200 bg-green-50`}>
                {children}
            </div>
        );
    }

    if (tone === "negative") {
        return (
            <div className={`${className} p-2 outline outline-[1px] outline-offset-[-1px] outline-red-200 bg-red-50`}>
                {children}
            </div>
        );
    }

    if (tone === "neutral") {
        return (
            <div className={`${className} p-2 outline outline-[1px] outline-offset-[-1px] outline-amber-200 bg-amber-50`}>
                {children}
            </div>
        );
    }

    return (
        <div className={`${className} p-2 outline outline-[1px] outline-offset-[-1px] outline-gray-200 bg-gray-50`}>
            {children}
        </div>
    );
}